<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navBlog"/>
          </span>
          <div>
            <h1 class="pl-card__title">برچسب‌های بلاگ</h1>
            <p class="pl-card__sub">پست‌ها بر اساس برچسب و بدون برچسب</p>
          </div>
        </div>
      </div>

      <div class="pl-card__body">
        <div
          v-if="(!items_tags.tags || items_tags.tags.length === 0) && (!items_tags.non_tags || items_tags.non_tags.length === 0)"
          class="pl-empty"
        >
          <span class="pl-empty__icon" aria-hidden="true">
            <CIcon name="navBlog"/>
          </span>
          <p class="pl-empty__title">پستی یافت نشد</p>
          <p class="pl-empty__sub">هنوز پستی برای نمایش در برچسب‌ها وجود ندارد.</p>
        </div>

        <div v-else class="tags-list-groups">
          <div
            v-for="(tag, tagIndex) in items_tags.tags"
            :key="'tag-' + tagIndex"
            class="pl-card tags-list-group"
          >
            <div class="pl-card__header tags-list-group__header">
              <div class="pl-card__title-wrap">
                <span class="pl-card__icon tags-list-group__icon" aria-hidden="true">
                  <CIcon name="iconList"/>
                </span>
                <div>
                  <h2 class="pl-card__title tags-list-group__title">{{ tag.title.title }}</h2>
                  <p class="pl-card__sub">{{ tag.post_tags.length }} پست</p>
                </div>
              </div>
            </div>
            <div class="pl-card__body tags-list-group__body">
              <div v-if="!tag.post_tags || tag.post_tags.length === 0" class="pl-muted tags-list-group__empty">
                پستی در این برچسب نیست.
              </div>
              <ul v-else class="tags-list-posts">
                <li
                  v-for="(post, postIndex) in tag.post_tags"
                  :key="'tag-post-' + tagIndex + '-' + postIndex"
                  class="tags-list-post"
                >
                  <span class="pl-name tags-list-post__title">{{ post.post.title.title }}</span>
                  <button
                    type="button"
                    class="pl-btn pl-btn--sm pl-btn--ghost"
                    @click="open_edit(post.post.id)"
                  >
                    <CIcon name="iconEdit"/>
                    <span>ویرایش</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div class="pl-card tags-list-group">
            <div class="pl-card__header tags-list-group__header">
              <div class="pl-card__title-wrap">
                <span class="pl-card__icon tags-list-group__icon" aria-hidden="true">
                  <CIcon name="iconList"/>
                </span>
                <div>
                  <h2 class="pl-card__title tags-list-group__title">بدون برچسب</h2>
                  <p class="pl-card__sub">{{ items_tags.non_tags ? items_tags.non_tags.length : 0 }} پست</p>
                </div>
              </div>
            </div>
            <div class="pl-card__body tags-list-group__body">
              <div
                v-if="!items_tags.non_tags || items_tags.non_tags.length === 0"
                class="pl-muted tags-list-group__empty"
              >
                پست بدون برچسبی نیست.
              </div>
              <ul v-else class="tags-list-posts">
                <li
                  v-for="(post, postIndex) in items_tags.non_tags"
                  :key="'non-tag-' + postIndex"
                  class="tags-list-post"
                >
                  <span class="pl-name tags-list-post__title">{{ post.title.title }}</span>
                  <button
                    type="button"
                    class="pl-btn pl-btn--sm pl-btn--ghost"
                    @click="open_edit(post.id)"
                  >
                    <CIcon name="iconEdit"/>
                    <span>ویرایش</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CModal
      :show.sync="edit_title_modal"
      :centered="true"
      size="md"
      title="ویرایش عنوان"
      @update:show="onEditTitleModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12">
            <CInput
              v-model="name"
              label="عنوان"
              placeholder="عنوان"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeEditTitleModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="edit()">
          <CIcon name="iconCheck"/>
          <span>ویرایش</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
    import axios from "@/api/http";
    var items_tags = [

    ];


    const fields = [
      {key: 'row',label: '#', _style: 'width:10%'},
        {key: 'عنوان', _style: 'width:10%'},
        {key: 'تعداد', _style: 'width:10%'},

        {key: 'عملیات', _style: 'width:30%;'},

    ];


    export default {
        name: 'Tags',
        data() {
            return {
                name: '',
                file: '',
                color: '',
                previewImage: '',
                description: '',
                selected_item: '',
                items_tags: items_tags.map((item, id) => {
                    return {...item, id}
                }),
                fields,

                details: [],
                collapseDuration: 0,
                status_form: 0
            }
        },
        computed: {
            edit_title_modal: {
                get() {
                    return this.status_form !== 0;
                },
                set(value) {
                    if (!value) {
                        this.closeEditTitleModal();
                    }
                }
            }
        },
        mounted() {
            this.get_data();
        },
        methods: {
          open_edit(post_id){
            window.open("/dashboard/news/edit-news/"+post_id)
          },
          closeEditTitleModal() {
              this.status_form = 0;
              this.name = '';
              this.selected_item = '';
          },
          onEditTitleModalToggle(show) {
              if (!show) {
                  this.closeEditTitleModal();
              }
          },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            editDetails(item) {

                    // this.$set(this.items[item.id], '_toggled', !item._toggled)
                    this.name = this.items_tags[item.row_id].name;
                    this.selected_item = item;

                    this.status_form = this.items_tags[item.row_id].id;
                    // this.$nextTick(() => {
                    //     this.collapseDuration = 0
                    // })

            }, get_data() {
                var self = this;
                // console.log("route id "+this.$route.params.cat_id);

                axios.post('/api/admin/blog/blog_tags', {}).then(function (response) {

                    var contents = response.data;

                    // items = content_cats.orders;

                    self.items_tags = contents
                    // console.log("cats is " + self.items_active);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goRegister() {
                this.$router.push({path: 'register'});
            }, edit() {


                let self = this;
                // const formData = new FormData()
                let url;
                url = "/api/admin/tags";


                axios.post(  url, {
                    name: self.name,
                    // roles: self.$refs.permissions,
                    id: self.status_form,
                }).then(function (response) {

                    self.items_tags[self.selected_item.row_id].name=self.name;
                    self.selected_item = '';

                    self.name = '';
                    self.status_form=0;
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
        }
    }


</script>

<style scoped>
.tags-list-groups {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tags-list-group {
  border-radius: 12px;
  box-shadow: none;
}

.tags-list-group__header {
  padding: 12px 14px;
}

.tags-list-group__body {
  padding: 8px 14px 14px;
}

.tags-list-group__icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
}

.tags-list-group__title {
  font-size: 15px;
  font-weight: 700;
}

.tags-list-group__empty {
  padding: 8px 0;
  font-size: 13px;
}

.tags-list-posts {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tags-list-post {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid var(--panel-border, rgba(128, 148, 174, .14));
  border-radius: 12px;
  background: var(--panel-surface-2, #f7f8fb);
}

.tags-list-post__title {
  flex: 1;
  min-width: 0;
}
</style>
